export default {
  namespaced: true,

  state: () => ({
    merchants: {
      data: [],
      links: {},
      meta: {},
    },
    merchant: {},
    selectedCouriers: [],
  }),

  mutations: {
    SET_MERCHANT_LIST(state, payload) {
      state.merchants = payload
    },
    SET_MERCHANT(state, payload) {
      state.merchant = payload
    },
    SET_SELECTED_COURIERS(state, payload) {
      state.selectedCouriers = payload
    },
    PUSH_SELECTED_COURIER(state, payload) {
      state.selectedCouriers.push(payload)
    },
    DELETE_SELECTED_COURIER(state, index) {
      state.selectedCouriers.splice(index, 1)
    },
  },

  actions: {
    // get
    async getMerchantList({ commit }, { page = null, keyword = '', limit = 100 } = {}) {
      try {
        const url = `/v1/admin/merchants?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page, limit } })

        commit('SET_MERCHANT_LIST', response.data)

        return response.data
      } catch (error) {
        return error
      }
    },
    async getMerchantProfile({ commit }, { id }) {
      try {
        const url = `/v1/admin/merchants/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_MERCHANT', response.data.data)
        commit('SET_SELECTED_COURIERS', response.data.data.courier_merchants)

        return response.data
      } catch (error) {
        return error
      }
    },
    // create
    async createMerchantProfile({ commit }, data) {
      try {
        const url = '/v1/admin/merchants'

        const formData = new FormData()
        formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('email', data.email)
        formData.append('password', data.password)
        formData.append('order', data.order)
        formData.append('phone', data.phone)
        formData.append('description', data.description)
        formData.append('is_active', data.is_active)
        formData.append('is_open', data.is_open)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Merchant!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Merchant!',
        }, { root: true })

        return error
      }
    },
    async createMerchantAddress({ commit }, { data, merchantId }) {
      try {
        const url = `/v1/admin/merchants/${merchantId}/address`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Alamat Merchant!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Alamat Merchant!',
        }, { root: true })

        return error
      }
    },
    // edit
    async editMerchantProfile({ commit }, { data, merchantId }) {
      try {
        const url = `/v1/admin/merchants/${merchantId}`

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('email', data.email)
        formData.append('password', data.password)
        formData.append('order', data.order ? data.order : '')
        formData.append('phone', data.phone)
        formData.append('description', data.description)
        formData.append('is_active', data.is_active)
        formData.append('is_open', data.is_open)
        formData.append('close_', data.is_open)
        formData.append('close_started_at', data.close_started_at)
        formData.append('close_ended_at', data.close_ended_at)
        formData.append('close_desc', data.close_desc)
        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Merchant!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Merchant!',
        }, { root: true })

        return error
      }
    },
    async pushCourier({ commit }, { data, merchantId }) {
      try {
        const url = `/v1/admin/merchants/${merchantId}/courier`
        const response = await this._vm.$http.post(url, { courier_id: data.id })

        const newData = response.data.data.courier_merchants.find(el => el.courier_id === data.id)

        commit('PUSH_SELECTED_COURIER', newData)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kurir!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Kurir!',
        }, { root: true })

        return error
      }
    },
    async deleteCourier({ commit }, { index, data, merchantId }) {
      try {
        const url = `/v1/admin/merchants/${merchantId}/courier/${data.id}`
        const response = await this._vm.$http.delete(url)

        commit('DELETE_SELECTED_COURIER', index)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kurir!',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 ? error.response.data.message : 'Gagal Menghapus Kurir!',
        }, { root: true })

        return error
      }
    },
  },
}
